import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

let pageOpenedAt = Date.now();

export function secondsSince(timestamp: number) {
  return Math.round((Date.now() - timestamp) / 1000);
}

export function secondsOnPage() {
  return secondsSince(pageOpenedAt);
}

export default function useSecondsOnPageTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    pageOpenedAt = Date.now();
  }, [pathname]);
}
